import React from "react";
import "../../Styles/Modal.scss";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../Common/Styles/Icons.module.scss";
import { CLASSNAME_PREFIX } from "./classname";

type Props = {
  toggle?: () => void;
};

export const ModalHeader: React.FC<Props> = props => (
  <div className={`${CLASSNAME_PREFIX}header`}>
    <span className={`${CLASSNAME_PREFIX}header-text`}>{props.children}</span>
    {props.toggle ? (
      <span className={`${CLASSNAME_PREFIX}header-close`} onClick={props.toggle}>
        <Icon
          appName="GeneralLayout"
          assetName="GENERAL_L_RemoveX"
          className={iconStyles.smallIcon}
        />
      </span>
    ) : null}
  </div>
);
